export default __webpack_public_path__ + "static/media/50k.3f8bfa27.md";